<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <!--template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Open Dialog
        </v-btn>
      </template-->
      <v-card>
        <v-toolbar
          dark
          color="primary"
          elevation="0"
        >
          <v-btn
            icon
            dark
            @click="onClose"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Share content</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              dark
              text
              @click="onClose"
            >
              Cerrar
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-layout wrap>
          <v-flex xs8 style="padding: 20px 10px 20px 20px">
            <list 
              v-if="dialog && workspaceID"
              :workspaceID="workspaceID"
              :shareWorkspaces="shareWorkspaces"
              :onEdit="handleEdit"
            />
          </v-flex>
          <v-flex xs4 style="padding: 20px 20px 20px 10px">
            <v-card
              style="min-height:calc(100vh - 104px);"
              elekvation="0"
            >
              <v-card-text>
                <v-btn
                  v-if="!editedID"
                  block
                  color="primary"
                  @click="handleAdd"
                >
                  {{ $t('common.add', locale) }}
                </v-btn>
                <share-workspace-form
                  :workspaceID="workspaceID"
                  :allWorkspaces="allWorkspaces"
                  :editedID="editedID"
                  :onClose="handleCloseForm"
                />
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import List from './List'
import ShareWorkspaceForm from './ShareWorkspaceForm'
export default {
  name: 'DialogWorkspaceShareContent',
  components: {
    List,
    ShareWorkspaceForm,
  },
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    workspaceID: {
      type: String,
      required: true,
    },
    allWorkspaces: {
      type: Array,
      required: true,
    },
    shareWorkspaces: {
      type: Array,
      required: true,
    },
    onRefresh: {
      type: Function,
      required: true,
    },
    onSave: {
      type: Function,
      required: true,
    },
    onClose: {
      type: Function,
      required: true,
    },
    locale: {
      type: String,
      default: 'es',
    },
  },
  data: () => ({
    dialog: false,
    editedID: null,
    showForm: false,
  }),
  watch: {
    showDialog () {
      this.prepareDialog()
    },
  },
  mounted () {
    this.prepareDialog()
  },
  methods: {
    prepareDialog () {
      this.dialog = this.showDialog ? true : false
    },
    handleAdd () {
      this.editedID = 'new'
    },
    handleCloseForm (refresh) {
      if (refresh) this.onRefresh()
      this.editedID = null
    },
    handleSearch (v) {
      this.searchValue = v
    },
    handleEdit (v) {
      this.editedID = v
    },
  }
}
</script>
